webpackJsonp([198517197184460],{

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(16));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      flexShrink: 0,
	      width: 40,
	      height: 40,
	      fontFamily: theme.typography.fontFamily,
	      fontSize: theme.typography.pxToRem(20),
	      borderRadius: '50%',
	      overflow: 'hidden',
	      userSelect: 'none'
	    },
	
	    /* Styles applied to the root element if there are children and not `src` or `srcSet` */
	
	    /* Styles applied to the root element if `color="default"`. */
	    colorDefault: {
	      color: theme.palette.background.default,
	      backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
	    },
	
	    /* Styles applied to the img element if either `src` or `srcSet` is defined. */
	    img: {
	      width: '100%',
	      height: '100%',
	      textAlign: 'center',
	      // Handle non-square image. The property isn't supported by IE11.
	      objectFit: 'cover'
	    }
	  };
	};
	
	exports.styles = styles;
	
	function Avatar(props) {
	  var alt = props.alt,
	      childrenProp = props.children,
	      childrenClassNameProp = props.childrenClassName,
	      classes = props.classes,
	      classNameProp = props.className,
	      Component = props.component,
	      imgProps = props.imgProps,
	      sizes = props.sizes,
	      src = props.src,
	      srcSet = props.srcSet,
	      other = (0, _objectWithoutProperties2.default)(props, ["alt", "children", "childrenClassName", "classes", "className", "component", "imgProps", "sizes", "src", "srcSet"]);
	  var className = (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.colorDefault, childrenProp && !src && !srcSet), classNameProp);
	  var children = null;
	
	  if (src || srcSet) {
	    children = _react.default.createElement("img", (0, _extends2.default)({
	      alt: alt,
	      src: src,
	      srcSet: srcSet,
	      sizes: sizes,
	      className: classes.img
	    }, imgProps));
	  } else if (childrenClassNameProp && _react.default.isValidElement(childrenProp)) {
	    var childrenClassName = (0, _classnames.default)(childrenClassNameProp, childrenProp.props.className);
	    children = _react.default.cloneElement(childrenProp, {
	      className: childrenClassName
	    });
	  } else {
	    children = childrenProp;
	  }
	
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: className
	  }, other), children);
	}
	
	Avatar.propTypes =  false ? {
	  /**
	   * Used in combination with `src` or `srcSet` to
	   * provide an alt attribute for the rendered `img` element.
	   */
	  alt: _propTypes.default.string,
	
	  /**
	   * Used to render icon or text elements inside the Avatar.
	   * `src` and `alt` props will not be used and no `img` will
	   * be rendered by default.
	   *
	   * This can be an element, or just a string.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   * The className of the child element.
	   * Used by Chip and ListItemIcon to style the Avatar icon.
	   */
	  childrenClassName: _propTypes.default.string,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * Attributes applied to the `img` element if the component
	   * is used to display an image.
	   */
	  imgProps: _propTypes.default.object,
	
	  /**
	   * The `sizes` attribute for the `img` element.
	   */
	  sizes: _propTypes.default.string,
	
	  /**
	   * The `src` attribute for the `img` element.
	   */
	  src: _propTypes.default.string,
	
	  /**
	   * The `srcSet` attribute for the `img` element.
	   */
	  srcSet: _propTypes.default.string
	} : {};
	Avatar.defaultProps = {
	  component: 'div'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiAvatar'
	})(Avatar);
	
	exports.default = _default;

/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Avatar.default;
	  }
	});
	
	var _Avatar = _interopRequireDefault(__webpack_require__(190));

/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(9);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = function styles(theme) {
	  return {
	    disqusWrapper: {
	      '& a': {
	        color: theme.main.colors.link,
	        '&:hover': {
	          color: theme.main.colors.linkHover
	        }
	      }
	    }
	  };
	};
	
	var Disqus = function (_React$Component) {
	  _inherits(Disqus, _React$Component);
	
	  function Disqus(props) {
	    _classCallCheck(this, Disqus);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = props;
	    return _this;
	  }
	
	  Disqus.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    this.setState(nextProps);
	  };
	
	  Disqus.prototype.componentDidMount = function componentDidMount() {
	    if (typeof window != 'undefined' && window.document) {
	      var component = this;
	      window.disqus_config = function () {
	        this.page.identifier = component.state.identifier;
	        this.page.title = component.state.title;
	        this.page.url = component.state.url;
	        // this.page.category_id = component.state.category_id;
	        // this.callbacks.onNewComment = component.state.onNewComment;
	      };
	
	      var script = document.createElement('script');
	      script.src = "https://" + this.state.shortname + ".disqus.com/embed.js";
	      script.async = true;
	      script.setAttribute('data-timestamp', +new Date());
	      (document.head || document.body).appendChild(script);
	    }
	  };
	
	  Disqus.prototype.render = function render() {
	    var classes = this.props.classes;
	
	    return _react2.default.createElement("div", { id: "disqus_thread", className: classes.disqusWrapper });
	  };
	
	  return Disqus;
	}(_react2.default.Component);
	
	Disqus.propTypes = {
	  /**
	   * `shortname` tells the Disqus service your forum's shortname,
	   * which is the unique identifier for your website as registered
	   * on Disqus. If undefined , the Disqus embed will not load.
	   */
	  shortname: _propTypes2.default.string.isRequired,
	
	  /**
	   * `identifier` tells the Disqus service how to identify the
	   * current page. When the Disqus embed is loaded, the identifier
	   * is used to look up the correct thread. If disqus_identifier
	   * is undefined, the page's URL will be used. The URL can be
	   * unreliable, such as when renaming an article slug or changing
	   * domains, so we recommend using your own unique way of
	   * identifying a thread.
	   */
	  identifier: _propTypes2.default.string.isRequired,
	
	  /**
	   * `title` tells the Disqus service the title of the current page.
	   * This is used when creating the thread on Disqus for the first time.
	   * If undefined, Disqus will use the <title> attribute of the page.
	   * If that attribute could not be used, Disqus will use the URL of the page.
	   */
	  title: _propTypes2.default.string,
	
	  /**
	   * `url` tells the Disqus service the URL of the current page.
	   * If undefined, Disqus will take the global.location.href.
	   * This URL is used to look up or create a thread if disqus_identifier
	   * is undefined. In addition, this URL is always saved when a thread is
	   * being created so that Disqus knows what page a thread belongs to.
	   */
	  url: _propTypes2.default.string,
	
	  /**
	   * `category_id` tells the Disqus service the category to be used for
	   * the current page. This is used when creating the thread on Disqus
	   * for the first time.
	   */
	  category_id: _propTypes2.default.string,
	
	  /**
	   * `onNewComment` function accepts one parameter `comment` which is a
	   * JavaScript object with comment `id` and `text`. This allows you to track
	   * user comments and replies and run a script after a comment is posted.
	   */
	  onNewComment: _propTypes2.default.func
	};
	
	exports.default = (0, _reactJss2.default)(styles)(Disqus);
	module.exports = exports["default"];

/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Disqus = __webpack_require__(570);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Disqus).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(9);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _config = __webpack_require__(50);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _github = __webpack_require__(304);
	
	var _github2 = _interopRequireDefault(_github);
	
	var _linkedin = __webpack_require__(305);
	
	var _linkedin2 = _interopRequireDefault(_linkedin);
	
	var _medium = __webpack_require__(306);
	
	var _medium2 = _interopRequireDefault(_medium);
	
	var _twitter = __webpack_require__(307);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    social: {
	      display: "flex",
	      justifyContent: "center",
	      flexWrap: "wrap"
	    },
	    link: {
	      display: "inline-block",
	      paddingTop: "1em",
	      "& + a": {
	        paddingLeft: "1em"
	      },
	      "&:hover": {
	        "& svg": {
	          fill: theme.info.colors.socialIconsHover
	        }
	      }
	    },
	    svg: {
	      width: "2em",
	      height: "2em",
	      fill: theme.info.colors.socialIcons,
	      transition: "all .5s"
	    }
	  };
	};
	
	var Socialcons = function Socialcons(props) {
	  var classes = props.classes;
	
	  var items = _config2.default.authorSocialLinks;
	  var icons = {
	    github: _github2.default,
	    linkedin: _linkedin2.default,
	    medium: _medium2.default,
	    twitter: _twitter2.default
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: classes.social },
	    items.map(function (item) {
	      var Icon = icons[item.name];
	      return _react2.default.createElement(
	        "a",
	        {
	          href: item.url,
	          key: item.name,
	          className: classes.link,
	          target: "_blank",
	          rel: "noopener noreferrer",
	          title: item.name
	        },
	        _react2.default.createElement(Icon, { className: classes.svg })
	      );
	    })
	  );
	};
	
	Socialcons.propTypes = {
	  classes: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactJss2.default)(styles)(Socialcons);
	module.exports = exports["default"];

/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Article = __webpack_require__(145);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _PostHeader = __webpack_require__(597);
	
	var _PostHeader2 = _interopRequireDefault(_PostHeader);
	
	var _Content = __webpack_require__(213);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _PostFooter = __webpack_require__(596);
	
	var _PostFooter2 = _interopRequireDefault(_PostFooter);
	
	var _config = __webpack_require__(50);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Post = function Post(props) {
	  var author = props.author,
	      slug = props.slug,
	      disqus = props.disqus,
	      facebook = props.facebook;
	
	  var post = props.post || {};
	
	  var _ref = post.frontmatter || {},
	      identifier = _ref.id,
	      title = _ref.title,
	      subTitle = _ref.subTitle,
	      category = _ref.category;
	
	  var date = (post.fields || {}).prefix;
	
	  return _react2.default.createElement(
	    _Article2.default,
	    null,
	    _react2.default.createElement(_PostHeader2.default, { title: title, subTitle: subTitle, category: category, date: date, timeToRead: post.timeToRead }),
	    _react2.default.createElement(_Content2.default, { html: post.html }),
	    _react2.default.createElement(_PostFooter2.default, _extends({ post: post, slug: slug, facebook: facebook }, {
	      author: _extends({}, author, { name: _config2.default.authorName }),
	      disqus: _extends({}, disqus, { identifier: identifier, title: title, url: _config2.default.siteUrl + slug }) }))
	  );
	};
	
	Post.propTypes = {
	  post: _propTypes2.default.object.isRequired,
	  author: _propTypes2.default.object.isRequired,
	  slug: _propTypes2.default.string.isRequired,
	  disqus: _propTypes2.default.object.isRequired,
	  facebook: _propTypes2.default.object.isRequired
	};
	
	exports.default = Post;
	module.exports = exports["default"];

/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(9);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _Avatar = __webpack_require__(191);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _avatar2 = __webpack_require__(185);
	
	var _avatar3 = _interopRequireDefault(_avatar2);
	
	var _SocialIcons = __webpack_require__(212);
	
	var _SocialIcons2 = _interopRequireDefault(_SocialIcons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  var _author, _avatar;
	
	  return {
	    author: (_author = {
	      margin: "3em 0 0",
	      padding: "3em 0 0",
	      borderTop: "1px solid #ddd",
	      display: "flex",
	      flexDirection: "column",
	      alignItems: "center",
	      "& a": {
	        color: theme.base.colors.link
	      }
	    }, _author["@media (min-width: " + theme.mediaQueryTresholds.M + "px)"] = {
	      flexDirection: "row",
	      justifyContent: "center"
	    }, _author),
	    avatar: (_avatar = {
	      margin: "0 1em 1em",
	      borderRadius: "75% 65%",
	      width: "60px",
	      height: "60px",
	      border: "1px solid #ddd",
	      flexShrink: 0
	    }, _avatar["@media (min-width: " + theme.mediaQueryTresholds.M + "px)"] = {
	      margin: "0 1em 0"
	    }, _avatar),
	    box: {
	      display: "flex",
	      flexDirection: "column",
	      minHeight: "50px",
	      "& > :last-child": {
	        fontSize: "12px",
	        justifyContent: "start"
	      }
	    }
	  };
	};
	
	var PostAuthor = function PostAuthor(props) {
	  var classes = props.classes,
	      author = props.author;
	
	
	  return _react2.default.createElement(
	    "div",
	    { className: classes.author },
	    _react2.default.createElement(_Avatar2.default, { src: _avatar3.default, className: classes.avatar, alt: author.name }),
	    _react2.default.createElement(
	      "div",
	      { className: classes.box },
	      _react2.default.createElement("span", { dangerouslySetInnerHTML: { __html: author.html } }),
	      _react2.default.createElement(_SocialIcons2.default, null)
	    )
	  );
	};
	
	PostAuthor.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  author: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactJss2.default)(styles)(PostAuthor);
	module.exports = exports["default"];

/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(9);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _Disqus = __webpack_require__(571);
	
	var _Disqus2 = _interopRequireDefault(_Disqus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import FacebookProvider, { Comments } from "react-facebook";
	__webpack_require__(107);
	
	var styles = function styles(theme) {
	  return {
	    postComments: {
	      margin: "3em 0 0",
	      padding: "3em 0 0",
	      borderTop: "1px solid #ddd"
	    }
	  };
	};
	
	var PostComments = function PostComments(_ref) {
	  var classes = _ref.classes,
	      post = _ref.post,
	      slug = _ref.slug,
	      disqus = _ref.disqus;
	  return _react2.default.createElement(
	    "div",
	    { id: "post-comments", className: classes.postComments },
	    _react2.default.createElement(_Disqus2.default, disqus)
	  );
	};
	
	PostComments.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  post: _propTypes2.default.object.isRequired,
	  slug: _propTypes2.default.string.isRequired,
	  theme: _propTypes2.default.object.isRequired,
	  facebook: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactJss2.default)(styles)(PostComments);
	module.exports = exports["default"];

/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(9);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _AsyncComponent = __webpack_require__(217);
	
	var _AsyncComponent2 = _interopRequireDefault(_AsyncComponent);
	
	var _PostAuthor = __webpack_require__(594);
	
	var _PostAuthor2 = _interopRequireDefault(_PostAuthor);
	
	var _PostComments = __webpack_require__(595);
	
	var _PostComments2 = _interopRequireDefault(_PostComments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(107);
	
	var styles = function styles(theme) {
	  return {
	    footer: {
	      color: theme.main.colors.footer,
	      fontSize: theme.main.fonts.footer.size + "em",
	      lineHeight: theme.main.fonts.footer.lineHeight,
	      "& p": {
	        margin: 0
	      }
	    }
	  };
	};
	
	var PostShare = (0, _AsyncComponent2.default)(function () {
	  return new Promise(function (resolve) {
	    __webpack_require__.e/* nsure */(0, function (require) {
	      resolve(__webpack_require__(598));
	    });
	  }).then(function (module) {
	    return module;
	  }).catch(function (error) {});
	});
	
	var PostFooter = function PostFooter(_ref) {
	  var classes = _ref.classes,
	      author = _ref.author,
	      post = _ref.post,
	      slug = _ref.slug,
	      disqus = _ref.disqus,
	      facebook = _ref.facebook;
	
	  return _react2.default.createElement(
	    "footer",
	    { className: classes.footer },
	    _react2.default.createElement(PostShare, { post: post, slug: slug }),
	    _react2.default.createElement(_PostAuthor2.default, { author: author }),
	    _react2.default.createElement(_PostComments2.default, { post: post, slug: slug, disqus: disqus, facebook: facebook })
	  );
	};
	
	PostFooter.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  author: _propTypes2.default.object.isRequired,
	  post: _propTypes2.default.object.isRequired,
	  slug: _propTypes2.default.string.isRequired,
	  disqus: _propTypes2.default.object.isRequired,
	  facebook: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactJss2.default)(styles)(PostFooter);
	module.exports = exports["default"];

/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(9);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  var _title, _subTitle;
	
	  return {
	    header: {
	      margin: "0 0 3em"
	    },
	    title: (_title = {
	      color: theme.main.colors.title,
	      fontSize: theme.main.fonts.title.size + "em",
	      letterSpacing: "-0.04em",
	      fontWeight: theme.main.fonts.title.weight,
	      lineHeight: theme.main.fonts.title.lineHeight,
	      margin: "0 0 0.4em"
	    }, _title["@media (min-width: " + theme.mediaQueryTresholds.M + "px)"] = {
	      fontSize: theme.main.fonts.title.sizeM + "em"
	    }, _title["@media (min-width: " + theme.mediaQueryTresholds.L + "px)"] = {
	      fontSize: theme.main.fonts.title.sizeL + "em",
	      letterSpacing: "-0.05em"
	    }, _title),
	    subTitle: (_subTitle = {
	      color: theme.main.colors.subTitle,
	      fontSize: theme.main.fonts.subTitle.size + "em",
	      lineHeight: theme.main.fonts.subTitle.lineHeight,
	      fontWeight: theme.main.fonts.subTitle.weight
	    }, _subTitle["@media (min-width: " + theme.mediaQueryTresholds.M + "px)"] = {
	      fontSize: theme.main.fonts.subTitle.sizeM + "em"
	    }, _subTitle["@media (min-width: " + theme.mediaQueryTresholds.L + "px)"] = {
	      fontSize: theme.main.fonts.subTitle.sizeL + "em"
	    }, _subTitle),
	    meta: {
	      display: "inline-block",
	      fontSize: theme.main.fonts.meta.size + "em",
	      fontWeight: theme.main.fonts.meta.weight,
	      color: theme.main.colors.meta,
	      padding: "6px 1em 1em 0",
	      "& > span": {
	        display: "inline-block",
	        marginRight: "6px",
	        verticalAlign: "middle"
	      }
	    },
	    icon: {
	      color: theme.base.colors.link,
	      height: "20px",
	      width: "20px",
	      "& > svg": {
	        width: "100%",
	        height: "100%"
	      }
	    }
	  };
	};
	
	var PostHeader = function PostHeader(props) {
	  var classes = props.classes,
	      title = props.title,
	      subTitle = props.subTitle,
	      date = props.date,
	      category = props.category,
	      timeToRead = props.timeToRead;
	
	  var days = {
	    Mon: 'Pazartesi',
	    Tue: 'Salı',
	    Wed: 'Çarşamba',
	    Thu: 'Perşembe',
	    Fri: 'Cuma',
	    Sat: 'Cumartesi',
	    Sun: 'Pazar'
	  };
	
	  function myDate(dateString) {
	    var dateObj = new Date(dateString);
	    var dateToShow = dateObj.toISOString().split('T')
	    // .map(d => d.split('.')[0])
	    // .map(t => t.split(':').slice(0,2).join(':'))
	    .slice(0, 1).map(function (d) {
	      return d.split('-').reverse().join('.');
	    }).join(' ') + dateObj.toString().split(' ').slice(0, 1).map(function (day) {
	      return days[day];
	    }).reduce(function (acc, val) {
	      return acc + val;
	    }, ' ');
	
	    return dateToShow;
	  }
	
	  return _react2.default.createElement(
	    "header",
	    { className: classes.header },
	    _react2.default.createElement(
	      "h1",
	      { className: classes.title },
	      title
	    ),
	    _react2.default.createElement(
	      "h2",
	      { className: classes.subTitle },
	      subTitle
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: classes.meta },
	      _react2.default.createElement(
	        "span",
	        { className: classes.icon },
	        _react2.default.createElement(
	          "svg",
	          { "aria-label": "Tarih:", width: "1792", height: "1792", viewBox: "0 0 1792 1792", xmlns: "http://www.w3.org/2000/svg" },
	          _react2.default.createElement("path", { fill: "currentColor", d: "M192 1664h288v-288h-288v288zm352 0h320v-288h-320v288zm-352-352h288v-320h-288v320zm352 0h320v-320h-320v320zm-352-384h288v-288h-288v288zm736 736h320v-288h-320v288zm-384-736h320v-288h-320v288zm768 736h288v-288h-288v288zm-384-352h320v-320h-320v320zm-352-864v-288q0-13-9.5-22.5t-22.5-9.5h-64q-13 0-22.5 9.5t-9.5 22.5v288q0 13 9.5 22.5t22.5 9.5h64q13 0 22.5-9.5t9.5-22.5zm736 864h288v-320h-288v320zm-384-384h320v-288h-320v288zm384 0h288v-288h-288v288zm32-480v-288q0-13-9.5-22.5t-22.5-9.5h-64q-13 0-22.5 9.5t-9.5 22.5v288q0 13 9.5 22.5t22.5 9.5h64q13 0 22.5-9.5t9.5-22.5zm384-64v1280q0 52-38 90t-90 38h-1408q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h128v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h384v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h128q52 0 90 38t38 90z" })
	        )
	      ),
	      _react2.default.createElement(
	        "span",
	        null,
	        myDate(date)
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: classes.meta },
	      _react2.default.createElement(
	        "span",
	        { className: classes.icon },
	        _react2.default.createElement(
	          "svg",
	          { "aria-label": "Kategori:", width: "1792", height: "1792", viewBox: "0 0 1792 1792", xmlns: "http://www.w3.org/2000/svg" },
	          _react2.default.createElement("path", { fill: "currentColor", d: "M576 448q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zm1067 576q0 53-37 90l-491 492q-39 37-91 37-53 0-90-37l-715-716q-38-37-64.5-101t-26.5-117v-416q0-52 38-90t90-38h416q53 0 117 26.5t102 64.5l715 714q37 39 37 91z" })
	        )
	      ),
	      _react2.default.createElement(
	        "span",
	        null,
	        category
	      )
	    ),
	    timeToRead && _react2.default.createElement(
	      "div",
	      { className: classes.meta },
	      _react2.default.createElement(
	        "span",
	        { className: classes.icon },
	        _react2.default.createElement(
	          "svg",
	          { "aria-label": "Okuma s\xFCresi:", width: "1792", height: "1792", viewBox: "0 0 1792 1792", xmlns: "http://www.w3.org/2000/svg" },
	          _react2.default.createElement("path", { fill: "currentColor", d: "M1024 544v448q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h224v-352q0-14 9-23t23-9h64q14 0 23 9t9 23zm416 352q0-148-73-273t-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273zm224 0q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z" })
	        )
	      ),
	      _react2.default.createElement(
	        "span",
	        null,
	        timeToRead,
	        " dakika"
	      )
	    )
	  );
	};
	
	PostHeader.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  title: _propTypes2.default.string.isRequired,
	  subTitle: _propTypes2.default.string,
	  category: _propTypes2.default.string.isRequired,
	  date: _propTypes2.default.string.isRequired,
	  timeToRead: _propTypes2.default.number
	};
	
	exports.default = (0, _reactJss2.default)(styles)(PostHeader);
	module.exports = exports["default"];

/***/ }),

/***/ 599:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Post = __webpack_require__(593);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Post).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = asyncComponent;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function asyncComponent(getComponent, loadingComponent) {
	  var AsyncComponent = function (_React$Component) {
	    _inherits(AsyncComponent, _React$Component);
	
	    function AsyncComponent() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, AsyncComponent);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = { Component: null }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    AsyncComponent.prototype.componentDidMount = function componentDidMount() {
	      var _this2 = this;
	
	      if (!this.state.Component) {
	        getComponent().then(function (Component) {
	          _this2.setState({ Component: Component });
	        });
	      }
	    };
	
	    AsyncComponent.prototype.render = function render() {
	      var Component = this.state.Component;
	
	      if (Component) {
	        return _react2.default.createElement(Component, this.props);
	      }
	      return loadingComponent ? loadingComponent : _react2.default.createElement(
	        "div",
	        null,
	        "Loading..."
	      );
	    };
	
	    return AsyncComponent;
	  }(_react2.default.Component);
	
	  return AsyncComponent;
	}
	module.exports = exports["default"];

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _AsyncComponent = __webpack_require__(216);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AsyncComponent).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 185:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAASABIAAD/4QCMRXhpZgAATU0AKgAAAAgABQESAAMAAAABAAEAAAEaAAUAAAABAAAASgEbAAUAAAABAAAAUgEoAAMAAAABAAIAAIdpAAQAAAABAAAAWgAAAAAAAABIAAAAAQAAAEgAAAABAAOgAQADAAAAAQABAACgAgAEAAAAAQAAAPCgAwAEAAAAAQAAAPAAAAAA/+0AOFBob3Rvc2hvcCAzLjAAOEJJTQQEAAAAAAAAOEJJTQQlAAAAAAAQ1B2M2Y8AsgTpgAmY7PhCfv/AABEIAPAA8AMBIgACEQEDEQH/xAAfAAABBQEBAQEBAQAAAAAAAAAAAQIDBAUGBwgJCgv/xAC1EAACAQMDAgQDBQUEBAAAAX0BAgMABBEFEiExQQYTUWEHInEUMoGRoQgjQrHBFVLR8CQzYnKCCQoWFxgZGiUmJygpKjQ1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4eLj5OXm5+jp6vHy8/T19vf4+fr/xAAfAQADAQEBAQEBAQEBAAAAAAAAAQIDBAUGBwgJCgv/xAC1EQACAQIEBAMEBwUEBAABAncAAQIDEQQFITEGEkFRB2FxEyIygQgUQpGhscEJIzNS8BVictEKFiQ04SXxFxgZGiYnKCkqNTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqCg4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2dri4+Tl5ufo6ery8/T19vf4+fr/2wBDAAYGBgYGBgoGBgoOCgoKDhIODg4OEhcSEhISEhccFxcXFxcXHBwcHBwcHBwiIiIiIiInJycnJywsLCwsLCwsLCz/2wBDAQcHBwsKCxMKChMuHxofLi4uLi4uLi4uLi4uLi4uLi4uLi4uLi4uLi4uLi4uLi4uLi4uLi4uLi4uLi4uLi4uLi7/3QAEAA//2gAMAwEAAhEDEQA/APY6WiiuQ1EpaKXFADcUtGKXFIBtGKWigBKMUtFACUlOpKLgJikxTqSgBMUhpTgU0Mp4BHFFwDFFOooAZSU40lACUlOpKQCUlOpKAG0hp1JQA2ilpKAEooooA//Q9kxS0UuK5DUMUUtFACUYp1FIBtJT6TFADaXFOooAZSGlPHJrlNV1eeSRrHSh5kw4bP3QDxkn/JqZSS3KjBydkXtU12001CXYFs4Az1Pp+XNcX/wlmrX0Y+xwMp3EbiMDFalr4fjRhLft58pwefugj0Fa3kRRjCAD8K5pVWzuhhP5jkraTXy4muJcEjkfypLmXVxlkuMEjB471vT9cGsedsdTU85t9Xj2KkXiHVrYyeaocMwPy/lXW6f4ns7pQrna+Pung9q4l9rHHeqTwqTyPoR1q1UaMJ4ZPY9oSRJV3Icg07FeR2XiK70mQLckvAP4u47AH2HrXqNjf2uoQrNbOHBGeK3jNM45wcXZlukp2KTFUQJSUtFADaSnUlADaQinUlADaSnEUlAH/9H2fFLRS1xmolFLRQAlFLRQAUlLRSASq91dQWcDXNy2yNBkmrJIAyeleC+Ktdl8U66mkaRK7WsBKsU4V26E57gdB2pSdiox5nY7aXWbnxJc/ZNGMkUKn55ugI7jB6n+VdTZadBYQCKEE9yx5JPqTUWh6VFpdhHboOQOa1iCRXHOd2etSoqC0M5+5NU2bdxmrs+ckVmOcHGKybOpRILlARmubuuGJropn+XFc9d8ZpXHymQ7ENmo99Kwxkmqrtg1akZSgSyKjgqehqC08QTeEpQ5HmWbsAw7x5PX1I/yKQODwaguo0uIWhkGQwxWkZWOWpT5lZntml6rY6xareWEgkjbuOx9K0a+WfC3ia68F659humJsJWCuD/CD0YH27+36/UkciSxrLGwZWAII5BB7iuw8xqzsLikp1IaBDKQ06koASkp1JQA2m0+kNAH/9L2miilrjNQopaKAG0tFLQAlFLRSA4vx1rE2k6FILQhbi4/dxn+6P4m78gdPU4rmfh/4cNrB9smXDsM8+napPGEcmo+JbSxbd5UUe7A6Ek55/KvTdNt1htVVRjiuetLod2FgviZOFwMAUwITxVwIT9Kj24Jrlsd/MZFzEVBzWNIMtXS3GGBFc3cHa1JqxpCRnS8Z96xbld3JrXkYstZczenSpbNUzGmT8MVmS9K15jnj86xrgtk0JkSKjPjpS7yaqsW3YNLvxVpmEkc/wCKNPW5thcIPnSvU/hLr51HRW0m5kBmsSFUH7xiP3T7gdM+1cPchZIGVuRisv4dXD2HjWKFG2rOHjKnvkZ/Piu2hK8bdjzcTCzufUtJTqStTlGEUlPppFADaSnUlMBtIadTaQH/0/aqWilrjNRKKWikAlLRRQAUUUUAef6ihl8TSEc+XGmfbd0Feh2GDAoPYVwl1+71y4VeWlMePXheld9ZrthFctTc9Ch8JbwBxVSX1FTSMTnFUZJefmNZM6IorSo2MkVg3kbc10xdSCM5rNnhDkik4m0JWOKd2UlTxjpUBTeCcVfvoirEjtVS3YFCW7dKzsb3Mq4j281gXX3sE1s6nc4BANcq8vJBOaLClsMkwDmqjN82KsEhuTxVdgj8qRT5TBsWV8QsfauZ8PS+T4z05+f+PhQcc8EEf1rp1Xeuw96y/CsCr4806Nl3AytkH2jc/oRXVh92jz8StD6pxSU6krpOISkNOpKAGUlKaQ0ANpKdSUxn/9T2yiiiuI1ClopaAEoxR1paYBSYp1MdlVdzMEHAy3AyeBUyaSuyoRcmoo4TUHVNcmkPVAgB9AR/+uvQbc/uVx6V554itbmzne/lAZZNgyOOV4IPtiu9szuto8d0Fck3fU9GlBxXKxl7qUNhEWkBY9gK8g1nxvfidjaqojB+6PmP516LrEcH7ya4PyoPf8gO5rj5rexOYmjee7Kb/ssA+ZF7eYeAM47kD0zQmr8q1Zo4u3M3ZHFH4l6nCwEtm4xjkqwBz7gGuv0vx9YamAh/dS9CCcivHNZ16Nr57EWk9nMjBCrNyGOODtPuKtWWp3tuwjvE8wA9WX51+venUvFaxsKl7z92Vz2W9vEkQ+XySay7uX7MiZOCRWl4XtLbW4ROQVK9vX3rnPHcLWbBUOB7Vg9rnWpW0OW1fVoI2JdugzXA3fiadpClmmfes+9naWVt7FsGkghPl+eUeQA7Qka5OcbsfXAyfQc120qSW6uefWryl1siNrzWZ+zkdeM1ZtdX1G1bypUzk9+tRw6lFM+yFJEOM5B7fhV5ZPPI8wh17MOo+tXNpaSiYwV9YyOys51uI0mHBPUe9R+HZBD8RbHj5RIQfbdGw/mRVLTnMR8rPHao5Ptdr4kS9tX8tkjVw2ASDyOM9656bSbZrVi5JI+sKK858Ca1e6lNdW9xI0qQqjbnOcMxIwD9BzXo1dEJcyucdWm6cuViUlLSVRmNNJTqSgBlJTjSUxo//9X2ylxSiiuM1EFLRRQAUtFFIBKpalB9p0+eHGdyHj6c1eoqZx5ouJpRqOnONRdHcztTtI7zw1LzwYN2T6qMg1atOIYgP7g/lWP4icxaeltHxGwIx+PStPS5Rcafbzr/ABRr/KuFy1cex7PLp7To7lLY0106tjPUEjOPpTIbaTS/Na2VGEhJdWOCxPfPrVy5ieFzNGMn0qCa8hkixMdvFTCTi79QlDmVuh896n4atLPV5dSLTOHkMm2XDnJOcF+pA7Z5xxmqUzSXdz57EqB0IAr03VrKGeQ+Wu89R6Vp6B4RSSZbu/AOOVTtx3pupOo9TRUqdNXR0PhGyFlYpIU2FgDtHYnk1xnj9DcElBnHNevRwJGoVRgdq818XReWrkjI5x+NK1kTG0mz5intyJmQ8c56da0radGs20+TMYLb1aPKsrYxkfhkH1HFaN3bq0rH3qm1q6nOM+4610wraHHKj0ZRs9OhsiZlJkfGB8pAA/GpYbJvMM2cFuoq6qyNgEk1oQ2zsRngUp1pPccKKWwW8ZBBq5c7BcwyMcFo2UfUEGnbQnHpVTUX/eQL6bj/ACrCOtzW2qPZvh1ZCCzvLrj99MAP91VB/mTXotcX4BhePw8kr9ZZHb8Ado/lXaV3Ul7iPNxMr1ZMSkpaSrMBKSnU2gBpptPNNpgj/9b26lopa4zUSilooASilopAJRRRQBDc2UOoQG1myM8qw6g1jeHmFvHNpmctaStHz1x1H866GM4cH3riZpDpvjJ0yFiukV8e+Dn8yK5asFzXR6GHrNwUG9Ed75asMmud1W3jVTx1ro4mXgZzmsTWZF2ms3FNHXSb5rHnsriGTKdjXTaPqsfmKkjZY8ACuB1nUI4M5OCTV3wtHO8y6hcAiPPA74+lYRvfQ7pqLjqevCYPnb1Fef8Ait/Nhceldtb6jYFiYvmxxj3rzzxHdIkcu89cmtnsc0N9jxq9UrIWApbfZKmV702W+txITIwHPSsxJvLmLpxGx4o5TPmVzoVhQcgCpugxioIpNybs5pWbHFSzToRSZzxVfyDe6kkanmKMce7kBaJpgvzdh1rS8DCPVPE4ZlLKHQfggLD9RVwi3dnJOdmj6J02yTTbCCwi5WFAmfXHU/iauninCmmu5K2h5Td3diUlLRQAhpKWkNADe9IacKQ0Af/X9vpaKK4zUKKKKQBRRRQAUUUUAJXmXjQta6vZ3q56dc9Np6fkTXp1eefEaIf2Qlx3jkA/OpkrounKzNfStfSS1iZ8FnOM5rm/GXiu306HKnLHpXnNhr/lOY5ifkyQT0z9Pp+dYniO9W4vnnkbKxk7QO7MvH4AAk1zqm2+VnoKtyx5kYk3iOSe/NxeDeFyQoPGfU+v0FdLL8QGWz8m1i2Nt5AOM+vIzjjqe1ef6a51O9htooN7v8oXd15457DHU9T+Fev2nw9tbmBmkWa3kA2Mr4J/2vunof5VtOEIuzM6bq1LuLPMj4r1lpvOjuZVYHdgOcD2A6AD9e9Xb3x5fajZrDc4E+NrSgckepHTPvXS3vgayiby1m8pN2G3KQ2B7njk8k1zV74ZttOk4nRo3GDyG6Z4x160J0mW6GIjdnCzySRT+ZvLqTkE85q/Hq5IIbkUlxaqhb5lwCcAnPFZLxBONwP4108sZI4rzgzsNO1pd4RjkV0L3KFfMB4rycMyMGHUGuhGoN5Byeq1z1cNreJvTxTtaRe1HUGctEjcDnivevg9plomhy6sFzcTTSIWJJwqHAAHQZ74618xLJk5c98n6Dk19neArBtN8I6dbSLsk8kM4/2m5P8AOteRRVkc05uTuddSU6k7VJA2kpaKAEppp1IaAG0UtJQB/9D3ClpKWuM1EopaSkAUUUUAFFFFABWZrFgmpabPZuM+YhA9j2rTpKAPkCeJ7JriCf70J2MpHIJOOPXOc59M1lySxmNmCj/VsODn7oxgZr0z4p6ObPU11SM7YrlQsmOgYc/mRXlbl9oEQLYwD9SO+PerUb6l89hfCZSDUo5i4Q4yG/u5OMfX+VfUen+KNKeKNbttp24EnXOPWvk+dVs5CU+/0XA98f0q/a67dRoqNnETA8dQenOepPTFZVqTk+aJvRrcisz6Z1fVNDnXi5hJPGScHpXnWoX2lwxiFXikOf7wPNeXjUReyiMhlVjweuDjqf6fgKwmnGGj27ZJMPg9gRx/9f8AwqFQk9zp/tBxVkdTqElpI7NI6AZ7HJrlL17c5SIY9/WqMkwwwXjGcZ9apySk4reFG3U5KuJc9yI8EjtUgkITYelQmjknArpsclzqfCujS69rtrpqDKyPl/8ArmvL/px+NfcMMSQxLEgwqAKB6AdK8O+DPhr7NZy+IrlfmuB5cPsik5bp/Ef0Ar3SuebuykFJS0VAxuKSnGm0AJSGlpKACkpaSgD/0fcaKBRXGahRRRSAKSlpKACilpKACkpaSmBx3inT7LXoJdAnI854POQZwcg4DD/dJBr5jsX/ALHvrrTdRhDZVWJ6AeU3zEeoKnIFerfFfVbrR/EdlPA3lyIAFI7rsO78M4ryzXdWTUbiPUCFWZV5yMjOe4754NNXjNxezNWlKmmt0P1Syhiw7HIlIAxxtAXqcdD/ACJrmJ4ZIblGkIQq3JYYweCP0IPPauqjuRe2MDspEdptiJPzE5IQFj2zj8eMVl6ravDNHCeWcIVJG1Sx4JAPYnpntn0rVGRiM7q6QoBtUsQqjALHPJBz26dh2rPmLNI0pPz9D/TH0qdyRu3sflPPrx2FQ58xWlPALZ9uatIlsqu5K5PO7qagIyKnlC7AQfWomA3kL0H9KaJEUAqTVzTLVru8jiA4LDP0FVCAqAHua6HRJFtC1y47ZqKkuWLaLpxvJJn1/wCCvJTw1Z2sPAt0ERHuP8a6qvKPAOptHFHBOcC5APPZ+o/wr1euezWjG3d3CiiigBDTadSUANopTSUAJSU6mmmB/9L3GiiiuM1CiiigAoorNutVsrUHe+4jsvNCTewjSpK4ibxZNJJ5VjCCScc5J/pWxaTaq+JL10QddkagtWqoyeonKxvEgDJ4ArOttTjuNWhsLcb87nduwVB2/EgVFqkzpaHJKEnaFB9jnJ9jVHwbA0l5fai/IDLbx/RRvf8AUgfhWkKSWrJcjz/48aLJNb2WuRLn7OxjcjsshHP5gV88OgmhwRk19Ba/4ttfEXxMtvDcrs+lw+ZZOqHHmTSoQ7HnBCkBR6HNeU+JfCmoeEtSbTr1d0TZa3mH3ZIx0OccMOjD15HFTWi7c6NKMr+4zltN1N7N0s58m3YlXXsysc4P44/Wta/b7VerMZSyXGwySSEAAo4D7hwBtHp0rLmtlkPzLVY2wi3bgzjYVH8XJ9QaiM0ypQaKF5F5MsyryqswB/4Fx/hVEb2+QA45YD8Kvm2vGRCinAG0YHbOcf4U1bK9hkEixMHByvBGPeteZGfKzPQDeUfv6dc9qYflHXk1rQ6bfecr7fmzu5q9Hom0gv8AX6D0pOpFdRqnJmFFBJKwZuhretbWS6nis0By559gKuR2WzLOAB29q7bw7pUFvO0l1Ii3boHSAn94Iuu7Hvkd847cGoi+eRUlyROsiBtVjSM4IAKn0I5H617Vpt4L+whvB/y0UE+x6EfnXidy2RkdVqsNc1fTSh024dF5ynBU55zg8USjd6GcXofQdFcH4W8XtqyrBqQWOU8Ky8BmHYjsa7ysmraMoKKKKQxpptONJQAhptONIaYI/9P3GkZlUZY4FRyTIuI8EO3Q9jk4x7VVguI47wpJlg3C9eDxkfQ9KxVF9SudFk3EQG4k49cHH5mqr6jEuAgLFm2jH/1+Khlvm03UPLY74JQMZ7ZOP0Oap66kNtLDe2/CyjPHQH2rWNFbkOoZ2s3twBy2AOi56/l6Vw898Zt0ecP6Zz+R71Pqd/JdOVQ8/wAhWG1urD5hnqfxxVWtoVHudPon+jyGYgHZjk9s/wCNdvpzb5xKQMZLH3OMc1wdqv2ez2qMbiTXX6TIYrcyt2GPxPFWo6Gcpah4ivFjDkn5YVJP4cn+Rosb86D4A/tQkLL9me4+Y4HmzZYZPPGT+QrkvE90z6XcnvINv/fZA/qayvidqv2TwNYaTGcNeBQR6Ii8/wCH40NWQ07s8d8APaS+LrCXV3k8tptxcMVbzcFkLNyQPMxu/wAM19I6nBcavq9z4N8SL9qtbiIXNjeCPDxscjDYGN6EdRgMDyMZr5e0KKRNQgmiGWEgIH0Oa+y7DVrZNNF3cskaRx7ndyAFVR1Jx0A60uW6C9mfJ99pdxpmoTaZejE1s5QnGAcchh7EEH8aZ9kDZ4r2D4l6YmoC08VadtlheMJLJHyuw4MT5/u8kfiK8ziXIwa82tFwlY9Ok1ONzIFvKG2sxX6EgVbSKTGzOc9Mjt71p+SG68YqZEGM9qxczTkRXgt3YEED+lWWso1GSOeeasREjgCp52VU5qeZlcqKWi6Xb3+sLFdf8e8KPcz+8cIBI+hJAPtmuK1DUrpNRXV0JWcy+d83bP8AAcdtvy/SvSrEm18Ka1qQJU3DRWSEHkZ+ckf99f5FeSaqzOSy9BxXpYdWhfuediHedj12C8iv7WO8g+5Ku7Hp6g+46VlTMVlVc4Ofl9zg8Vz3gu8Jt5bBzyh3L9G/ya6e4TewI6j+laJamLZFok8vnPFIduORjtnqK9JsfFd9b4SVvNVeMOOuOOo5/OvOLFcal7OuPyNbbglXYdsnn2/z+nvQ4qQXseiz+PNMtnRLiGVA/RvlxnuOvaun0/VbLU032r54yVPBH4V4LeMJ4PKbGMZ9a3tKNzZwwmJirKMhgeaiVJNe6Ck+p7afWm1xNp4qlB8q6j83bjLJw34jp/KujtdY0+8+WGUB/wC63yt+RrFwa3NFJGlSGnU2pGj/1PW72cDodg7E9D9f8/8A18h5N2QMqcfMD1yMn8uB9aW+nktZjG+GR+BnlWz6/wCc/TPGV5iRv5sJJjGPlPJTnPB7qQDj/DFX5keTLGoTGdEJ6qGAPuOP1C5qLVrsnR7Yt1+cj6ZIH+fakmAVSH5J5H5bT/7NWXrbYs7KAH/liH/76JP+NUnoJrU5qJsuWPrz+tWkXzCAByf/AK9Z8ZP58/1rSdhaQea/DNwv4Ec/rU7lvQknuR5giTkAf4n+tdNezfY7aOyBw+Mv9Tn+XFcz4chW4vHvZv8AVWwDNnux4Uf1/CpLu5e5uGZjyxxz+X8x71pN7IzitWyl4jYjR2lPOSGA+hz/AFNcF8Qrs6lrNvbRHdFZWkUS/wC+3zP/AOyj8K9K8Qxg2MEZ53EE/n/+uuTg0S2di8g3k9d3Pb/61C1Wo3oYHhXRJpYf7QjUt5MyqQPQgHP617vpD20tsbNhuVco6H+7Kv0PHbpXHeHl8jWbqzQYjuIMKo6BoixGPqDUmkXJsta8iTlbn91z6jJXse4obElcpRX0ejG5+H3iESfYZyDaXCkE7ZXyu4nOCGHU5AOc4BFc1qugX2hXAgvBuVsmORfuuB1+hHcZrqfidZRS6faamy7jDKYX/wCuco6H/gSr6da3dCaPxl4FEM7eZeW6mLefvCaLhGY/7QweSMg9KnGYdVaftVubYas6cuR7HkrK+0hDg+/NTqpCgU3DK5VxggkEHsR1qZcHpXhnsDU60C3ub5zDbrnAyzH7qj1J/l61OEwNx4A4JqKTVLqKBbS3xEmScAcsT/ExPU9h0A6cVvQw7n7z2OevXUPdW5ra99g0/wAJWWlRymVjPJPLkY5PIBHPQkY57A15FMrzjew+UfrxXS6pNJNtjkYu55Ofocf5xVKSDCgEf56f0r0klsjzm3uzI0ib7FqsU2cKx2P9G/wODXp6LlyD3z/n868+XTpZz8oxnivQLTfJGsrjB2DIPHPGf5U+Ui5JaQ/6erD0Y/1/rWo3ylyf7x6/5+lSaZaE3SnHQEfrTLr927RNxnn9Oarl0JcjDht2luY7VGwHYAg9cZ7fgK7+OBZIN6Dp0/wrkLJC2qR8c4Yk+4Vv612WhyCXfbnquSPpxRCPccpdjOkixP15HGe/+e9WBCjEow3MOmOp/CpZo2S4KhSTn0/z71fkkhs4Q0nBI4A+8e3+BrNp30GmmtQstRvLZB9ncvGP4W5H09fyrqLPWra5xHN+5k/useD9D/jXEGUoTPIACxJYHovP/wBaongjRfPuX/d8hQ3UjPcd8+/Ss5U7lqVj/9X1KYQ3kX2a6wwbhHH+c457E8HoK4u7W40+f7PPznIRxzuB6j0+o9RyMLWt501vI+m3v+tT7jN/EB0zx785BHJ6Yputr9uslukG7AxIh5OPX3HTPJGM8iqTEytFOLiySVsfLy2OeCOcdf8Aaqn4jG25RAAAkSLx7Af/AFqp6XNyY87kJPJPJB556HPDZyepxWx4ltWa7AjOS4AB68dPU+1VYi+pzWm2guJf9lep9uRWVqdz9qudifdGMfoP8/0rqruM6RpQjz+/nwcegyDis7wrpf2m/W5ulPlQASsT3IK7R/31/KnCI5SNlrYaRpEWnkYkceZN/vNnA/4CMCsKAF7hR3J/z+o9q3dUumuZWdu/49gao6dCslyHHrnjp6/0NElqKL0LPiOL9xD7D/P9axoVwOO5/qRXY65brJaxkduOv+fU1zcFuzYyAcY/mP8AGmkJtCaavkaxbTH1OfyFVfF1s0F2ZovlOQwPowPX8xmrYBW+t2xxu/oBWz4qtPOgjmP8S4P+fxpPcIvQyZpl8UeHLnTzgSSxZXPOyReVOOvXbjgVQ8Ead4h8IyyT63AsFleKm4+YrPBLnanmKuSu8HbnOAQMkVjaNdT2F0Ap+6RwecEfn3x2qz4u+IlvPb3XhvT7aSOa5lEc8rsmxVkdXcx7fmYnPBbGPUmrjOduRLRjaV7jvGmnHT9aaZceXegzLjpngOPz56nrXMxdh7V6n45svN0G1vFO42jIGbqdsg2+/faeteWIV6149eHLNo9jDVOemmaCx+bakD/npj814rHuEWOXdJwFz+n+f89K6axRUgimfkGVmI/3QAP1rk71/NmKA57cdzj8e9d1PSmjz6utVmUqmecyOOpHpx0HtV/ydyA/56ZpIo8dO/8Ahn0rTCc46f5/+vWiMpMm0y1DEEjv7dsV0ZtlRcY9v5im6ZbERg4PP/6q0JhuXA78/wAj/WjqJbF7R4P3m4jsT/I1jeI7fyrpXHc4z+Yrt9Jt+D/u/wD1qxPFdvmBpR/B835c/wBatEs5PRGP9ouzdFgkf8tn/wBeug8PyY1eNB0YFT+lYWhkeZdt/dtnP/j2D+lanh0n+1IfUGqTE0bWo6ghupVh/wCWbFQfpxn9B6DjrWZBDcXMjXL5bYfu/ToB+X/6+tR3n7nV7hAPuyMR+PP689x1710cEJSFIl5LfNnr82eCMcdcZ61l1NehXSCEBribiBFBJJ+8c8D36An61gPLNqdwZ3+WNeAOcf0/lWjq85uroaXacRRHDY7t39vYZP6GraW0VtaM54C/0/z6fh97LJ8j/9k="

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function GithubIcon (props) {
	    return React.createElement("svg",props,React.createElement("path",{"d":"M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"}));
	}
	
	GithubIcon.displayName = "GithubIcon";
	
	GithubIcon.defaultProps = {"role":"img","viewBox":"0 0 24 24"};
	
	module.exports = GithubIcon;
	
	GithubIcon.default = GithubIcon;


/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function LinkedInIcon (props) {
	    return React.createElement("svg",props,React.createElement("path",{"d":"M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"}));
	}
	
	LinkedInIcon.displayName = "LinkedInIcon";
	
	LinkedInIcon.defaultProps = {"role":"img","viewBox":"0 0 24 24"};
	
	module.exports = LinkedInIcon;
	
	LinkedInIcon.default = LinkedInIcon;


/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function MediumIcon (props) {
	    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0v24h24V0H0zm19.938 5.686L18.651 6.92a.376.376 0 0 0-.143.362v9.067a.376.376 0 0 0 .143.361l1.257 1.234v.271h-6.322v-.27l1.302-1.265c.128-.128.128-.165.128-.36V8.99l-3.62 9.195h-.49L6.69 8.99v6.163a.85.85 0 0 0 .233.707l1.694 2.054v.271H3.815v-.27L5.51 15.86a.82.82 0 0 0 .218-.707V8.027a.624.624 0 0 0-.203-.527L4.019 5.686v-.27h4.674l3.613 7.923 3.176-7.924h4.456v.271z"}));
	}
	
	MediumIcon.displayName = "MediumIcon";
	
	MediumIcon.defaultProps = {"role":"img","viewBox":"0 0 24 24"};
	
	module.exports = MediumIcon;
	
	MediumIcon.default = MediumIcon;


/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function TwitterIcon (props) {
	    return React.createElement("svg",props,React.createElement("path",{"d":"M23.954 4.569c-.885.389-1.83.654-2.825.775 1.014-.611 1.794-1.574 2.163-2.723-.951.555-2.005.959-3.127 1.184-.896-.959-2.173-1.559-3.591-1.559-2.717 0-4.92 2.203-4.92 4.917 0 .39.045.765.127 1.124C7.691 8.094 4.066 6.13 1.64 3.161c-.427.722-.666 1.561-.666 2.475 0 1.71.87 3.213 2.188 4.096-.807-.026-1.566-.248-2.228-.616v.061c0 2.385 1.693 4.374 3.946 4.827-.413.111-.849.171-1.296.171-.314 0-.615-.03-.916-.086.631 1.953 2.445 3.377 4.604 3.417-1.68 1.319-3.809 2.105-6.102 2.105-.39 0-.779-.023-1.17-.067 2.189 1.394 4.768 2.209 7.557 2.209 9.054 0 13.999-7.496 13.999-13.986 0-.209 0-.42-.015-.63.961-.689 1.8-1.56 2.46-2.548l-.047-.02z"}));
	}
	
	TwitterIcon.displayName = "TwitterIcon";
	
	TwitterIcon.defaultProps = {"role":"img","viewBox":"0 0 24 24"};
	
	module.exports = TwitterIcon;
	
	TwitterIcon.default = TwitterIcon;


/***/ }),

/***/ 725:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 614:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.postQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Main = __webpack_require__(146);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _reactRedux = __webpack_require__(39);
	
	var _store = __webpack_require__(35);
	
	var _shared = __webpack_require__(57);
	
	var _Post = __webpack_require__(599);
	
	var _Post2 = _interopRequireDefault(_Post);
	
	var _Footer = __webpack_require__(326);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Seo = __webpack_require__(215);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(107);
	__webpack_require__(725);
	
	var PostTemplate = function (_React$Component) {
	  _inherits(PostTemplate, _React$Component);
	
	  function PostTemplate() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PostTemplate);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.moveNavigatorAside = _shared.moveNavigatorAside.bind(_this), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  PostTemplate.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.navigatorPosition === "is-featured") {
	      this.moveNavigatorAside();
	    }
	  };
	
	  PostTemplate.prototype.render = function render() {
	    var _props = this.props,
	        data = _props.data,
	        pathContext = _props.pathContext;
	
	    var _ref = ((data || {}).site || {}).siteMetadata || {},
	        disqus = _ref.disqus,
	        facebook = _ref.facebook;
	
	    return _react2.default.createElement(
	      _Main2.default,
	      null,
	      _react2.default.createElement(_Post2.default, {
	        post: data.post,
	        slug: pathContext.slug,
	        author: data.author,
	        disqus: disqus,
	        facebook: facebook
	      }),
	      _react2.default.createElement(_Footer2.default, { footnote: data.footnote }),
	      _react2.default.createElement(_Seo2.default, { data: data.post, facebook: facebook })
	    );
	  };
	
	  return PostTemplate;
	}(_react2.default.Component);
	
	PostTemplate.propTypes = {
	  data: _propTypes2.default.object.isRequired,
	  pathContext: _propTypes2.default.object.isRequired,
	  navigatorPosition: _propTypes2.default.string.isRequired,
	  setNavigatorPosition: _propTypes2.default.func.isRequired,
	  isWideScreen: _propTypes2.default.bool.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    navigatorPosition: state.navigatorPosition,
	    isWideScreen: state.isWideScreen
	  };
	};
	
	var mapDispatchToProps = {
	  setNavigatorPosition: _store.setNavigatorPosition,
	  setNavigatorShape: _store.setNavigatorShape
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PostTemplate);
	
	//eslint-disable-next-line no-undef
	
	var postQuery = exports.postQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-post-template-js-b89ddf57d67812a08326.js